const state = {
  categoryList: []
}

const mutations = {
  SET_CATEGORIES(state, list) {
    state.categoryList = list || []
  }
}

const actions = {
  fetchCategories({ commit }) {
    return new Promise((resolve, reject) => {
      import('@/api/category').then(({ getCategoryList }) => {
        getCategoryList()
          .then(data => {
            commit('SET_CATEGORIES', data || [])
            resolve(data)
          })
          .catch(error => reject(error))
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
